import type { Dispatch } from 'react';
import { SectionCard } from '../../anketa/components/SectionCard';
import { SectionHeader } from '../../anketa/components/SectionHeader';
import type { QuoteAction } from '../quoteReducer';
import type { QuoteState } from '../types';

/**
 * Block 12 PR-D-A Phase D4 Step 7 — раздел «Комментарии».
 *
 * Свободный textarea для комментариев исполнителя клиенту. PRD
 * `docs/prd/v4/10-block-12-calculator.md` §10.12.10:425-427 + прототип
 * `docs/prototypes/screen-2.12.10-cp.html` lines 321-328.
 *
 * Helper text + placeholder per прототип. `rows={5}` matches прототип
 * (line 326). Vertical resize разрешён (default browser behavior — пользователю
 * нужно потянуть для долгих комментариев).
 */
export interface SectionCommentsProps {
  state: QuoteState;
  dispatch: Dispatch<QuoteAction>;
}

export function SectionComments({ state, dispatch }: SectionCommentsProps) {
  return (
    <SectionCard testId="section-comments">
      <SectionHeader>Комментарии</SectionHeader>
      <p
        className="mb-2.5 leading-tight"
        style={{ fontSize: '13px', color: '#7a6a5a' }}
        data-testid="comments-helper"
      >
        Свободный текст: пожелания клиента, особенности заказа, нюансы доставки и сборки.
      </p>
      <textarea
        id="quote-comments-input"
        value={state.comments}
        onChange={(e) => dispatch({ type: 'SET_COMMENTS', value: e.target.value })}
        rows={5}
        aria-label="Комментарии"
        data-testid="comments-textarea"
        placeholder="Например: установка по адресу клиента, подъём на 5 этаж, согласование цвета фасадов на месте."
        className="w-full px-3 py-2.5 rounded-xl border-[1.5px] border-accent bg-card text-base text-ink leading-relaxed resize-y focus-visible:ring-2 focus-visible:ring-cta focus-visible:outline-none"
      />
    </SectionCard>
  );
}
